export const dropDownStyling = {
  singleValue: {
    paddingRight: '42px',
    marginLeft: '2px',
    color: '#4A4A4A',
  },
  control: {
    borderBottomColor: false,
    borderBottomHoverColor: '1px solid #AFAFAF',
    marginTop: '16px',
    fillSVGcolor: '#6D6E71',
    fillHoveredSVGcolor: '#6D6E71',
    borderBottonFocusColor: '1px solid #AFAFAF',
    fillFocusedSVGcolor: '#6D6E71',
    borderBottomFocusWithinColor: '1px solid #AFAFAF',
  },
  menuList: {
    maxHeight: '205px',
    marginTop: '0',
  },
  menu: {
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    boxShadow: '0 2px 20px #00000029',
    left: '0',
    width: 'auto',
  },
  dropdownIndicator: {
    padding: '8px',
    marginRight: '0',
  },
  clear: {
    display: 'none',
  },
  valueContainer: {
    marginTop: '20px',
  },
  styledSelectWrapper: {
    paddingTop: '8px',
  },
};

export const checkBoxStyling = {
  label: {
    fontSize: '14px',
  },
};

export const inputStylingProps = {
  border: {
    bottomBorderColor: '#AFAFAF',
    bottomBorderSize: '1px',
  },
  input: {
    placeholderColor: '#939598',
    placeholderStyle: 'normal',
    inputTextColor: '#4A4A4A',
  },
};
